const INPUT_UNSTYLED = "block m-0 p-0 w-full border-0 focus:outline-hidden focus:ring-0 bg-transparent";
const INPUT_NO_PADDING = "rounded-md text-sm flex w-full rounded-md border border-input bg-background ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 ring-inset focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50";
const INPUT = INPUT_NO_PADDING + " py-1.5";
const Styles = {
    INPUT_UNSTYLED,
    INPUT_NO_PADDING,
    INPUT
};
export { Styles };
//# sourceMappingURL=styles.js.map